import { WeekGame } from '../../../../user/model/interfaces';
import { ColumnType } from '@base/ui/components/dataTable';
import { t } from '@base/utils/helpers';

const weekgameColumns: ColumnType<WeekGame>[] = [
  {
    title: 'opponent',
    dataIndex: 'Opponent',
    render: (game) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px'
        }}
      >
        <span style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {game.Opponent}
        </span>
        <span style={{ textAlign: 'right', flex: '0 0 auto' }}>{game.ReportTime}</span>
      </div>
    ),
  },
  {
    title: 'result',
    dataIndex: 'MyResult',
    render: (game) => (
      <div style={{ textAlign: 'left' }}>
        {t(game.MyResult?.toLowerCase().replaceAll(' ', '_'))}
      </div>
    ),
    style: { width: '10rem' },
  },
  {
    title: 'my_rank',
    dataIndex: 'MyRank',
    style: { width: '5rem' },
  },
  {
    title: 'their_rank',
    dataIndex: 'TheirRank',
    style: { width: '5rem' },
  },
];

export default weekgameColumns;
